// extracted by mini-css-extract-plugin
export var actionText = "_s8-4";
export var container = "_s8-0";
export var leftSection = "_s8-1";
export var rightSection = "_s8-2";
export var settingsButton = "_s8-6";
export var settingsIcon = "_s8-7";
export var shortcut = "_s8-5";
export var shortcutGroup = "_s8-3";